import { CustomTaskDescription } from "@coworker/apprestructured/src/task-management/components/CustomTaskDescription/CustomTaskDescription";
import ChecklistItem from "@coworker/apprestructured/src/task-management/types/ChecklistItem";
import EmptyObject from "@coworker/apprestructured/src/task-management/types/EmptyObject";
import {
  CreatorFragmentCommonProps,
  CreatorFragmentHandle,
} from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { Ref, useCallback, useImperativeHandle } from "react";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import LoadingCreatorFragment from "@coworker/apprestructured/src/task-management/components/LoadingCreatorFragment/LoadingCreatorFragment";

export type CustomTaskDescriptionCreatorFragmentConfigProps = EmptyObject;

type CustomTaskDescriptionCreatorFragmentProps = {
  configProps: CustomTaskDescriptionCreatorFragmentConfigProps;
  commonProps: CreatorFragmentCommonProps;
  ref?: Ref<CreatorFragmentHandle>;
};

function CustomTaskDescriptionCreatorFragment({
  commonProps,
  ref,
}: CustomTaskDescriptionCreatorFragmentProps) {
  const { blockInput, task, onTaskChange, showValidation } = commonProps;
  const title = getByPath<string>(task, "title");
  const description = getByPath<string>(task, "details.description");
  const checklist = getByPath<ChecklistItem[]>(task, "details.checklist");

  const handleConfirmClick = useCallback(
    ({
      title,
      description,
      checklist,
    }: {
      title: string;
      description: string;
      checklist: ChecklistItem[];
    }) => {
      onTaskChange({ title, details: { description, checklist } });
    },
    [onTaskChange]
  );

  useImperativeHandle(ref, () => {
    return { valid: !isLoading(title) && !!title };
  });

  if (isLoading(title) || isLoading(description) || isLoading(checklist)) {
    return <LoadingCreatorFragment />;
  }

  return (
    <CustomTaskDescription
      title={title}
      description={description}
      checklist={checklist}
      onConfirmClick={handleConfirmClick}
      disabled={blockInput}
      showValidation={showValidation}
    />
  );
}

export default CustomTaskDescriptionCreatorFragment;
